// Not being used ATM

import React from "react";
import "./MenuPage.css";
import Navbar from "../components/Navbar";


export default function MenuPage() {

  
  const categories = [
    {
      name: "Food",
      image: "/food.jpg",
    },
    {
      name: "Dessert",
      image: "/food.jpg",
    },
    {
      name: "Drinks",
      image: "/food.jpg",
     },
  ];

  return (
    <div>
      <Navbar />
      
      <div className="menu-page">
        
        <h1 className="menu-heading">Menu</h1>

        <div className="menu-categories">
          {categories.map((cat) => (
            <div
              className="menu-category"
              key={cat.name}
              style={{ backgroundImage: `url(${cat.image})` }}
            >
              <div className="overlay"></div>
              <h2>{cat.name}</h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
